import { gql } from '@apollo/client';

// Fragment for reusable taxonomy fields
import { TAXONOMY_FIELDS_FRAGMENT } from '../fragments/taxonomyFields';

export const GET_TAXONOMY_DATA = gql`
  query GetTaxonomyData($id: ID!) {
    taxonomyFunction(id: $id) {
      id
      name
      office
      taxonomy {
        industry {
          id
        }
      }
      e2es {
        id
        name
        processes {
          id
          name
          subprocesses {
            id
            name
            description
            values {
              steps
              aiExamples
              technologies
            }
            diagram {
              id
              xmlImage
            }
            aiSolutions {
              id
              name
              impactAssessment {
                general
              }
            }
          }
        }
      }
    }
  }
`;

// Example of how to use a query with variables
export const GET_TAXONOMY_BY_ID = gql`
  query GetTaxonomyById($id: ID!) {
    taxonomyFunction(id: $id) {
      ...TaxonomyFields
      # Additional fields specific to this query
    }
  }
  ${TAXONOMY_FIELDS_FRAGMENT}
`;

export const GET_SUBPROCESS_DATA = gql`
  query GetSubprocessData($filters: TaxonomySubProcessFiltersType) {
    taxonomySubProcess {
      get(filters: $filters) {
        id
        name
        description
        kpis
        enterpriseApplicationsInUse
        files
        opportunity
        process {
          id
          name
          e2e {
            id
            name
            func {
              id
              name
            }
          }
        }
        diagram {
          id
          xmlData
          xmlImage
          data
        }
      }
    }
  }
`;

export const GET_TAXONOMY_DATA_LIST = gql`
  query GetTaxonomyDataList(
    $taxonomyFunctionFilters: TaxonomyFunctionFiltersType
    $taxonomyFunctionSort: [String!]
    $e2eFilters: TaxonomyE2EFiltersType
    $e2eSort: [String!]
    $processFilters: TaxonomyProcessFiltersType
    $processSort: [String!]
    $subprocessFilters: TaxonomySubProcessFiltersType
    $subprocessSort: [String!]
  ) {
    taxonomyFunction {
      fetch(filters: $taxonomyFunctionFilters, sort: $taxonomyFunctionSort) {
        __typename
        id
        name
        office
        taxonomy {
          industry {
            id
          }
        }
        e2es(filters: $e2eFilters, sort: $e2eSort) {
          __typename
          id
          name
          diagram {
            id
            xmlImage
          }
          processes(filters: $processFilters, sort: $processSort) {
            __typename
            id
            name
            diagram {
              id
              xmlImage
            }
            subprocesses(filters: $subprocessFilters, sort: $subprocessSort) {
              __typename
              id
              name
              kpis
              files
              processType
              creationSource
              status
              diagram {
                id
                xmlImage
                newAiOpportunities(filters: { isDeleted: false }) {
                  id
                  name
                  impactValue

                  __typename
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_INDUSTRIES_AND_TAXONOMY = gql`
  query ($v1: TaxonomyFunctionFiltersType, $v2: [String!]) {
    industry {
      fetch {
        id
        name
      }
    }
    taxonomyFunction {
      fetch(filters: $v1, sort: $v2) {
        id
        name
        taxonomy {
          industry {
            id
            name
          }
        }
      }
    }
  }
`;
